import {axios} from "~/plugins/request"

export const state = () => {
  return {}
}
export const mutations = {}
export const actions = {
  findCustomerForB({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`customer/findSalesCustomer`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  findCustomerForC({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`common/findCustomer`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getSysDate() {
    return new Promise((resolve, reject) => {
      axios.get(`common/getSysDate`).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  upload({commit}, params) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/seafile/uploadFile',
        method: 'post',
        data: params,
        headers: {'Content-Type': 'multipart/form-data'}
      }).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  customerId({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.get(`customer/customerId`, {params}).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  findSalesCustomerAll({commit}, params) {
    return new Promise((resolve, reject) => {
      axios.post(`customer/findSalesCustomerAll`, params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
}
